export default {
  header: {
    title: 'Super! Primești gratuit cu comanda ta:',
    subtitle: 'Vom aplica reducerea în procesul de finalizare.',
  },
  footer: {
    buttons: {
      no_thanks: 'Nu, mulțumesc',
      add_to_basket: 'Adaugă în coș',
    },
  },
};
